import React from "react"

export enum ButtonVariantsEnum {
    "PRIMARY" = "primary",
    "SECONDARY" = "secondary",
    "TERTIARY" = "tertiary"
}

export interface IButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: ButtonVariantsEnum
}